import { VFC } from 'react'
import { withLoginUser } from 'src/api/user'
import { PageProps } from 'src/components/hoc/asPage'
import { MessageContextProvider, RoomsQuery } from './MessageContext'
import { MessagesLayout } from './MessagesLayout'

export const Messages: VFC<PageProps<{}, RoomsQuery>> = withLoginUser(
  ({ user, router: { query } }) => (
    <MessageContextProvider user={user} query={query}>
      <MessagesLayout user={user} />
    </MessageContextProvider>
  ),
)
